
  import React from "react"
  import Component from "/Users/juahernandez/Developer/static.univision.com/especial/deportes/mundial-rusia-2018/ultras-mundial-racismo-en-la-otra-cara-del-mundial-src/src/layouts/internal.js"
  import data from "/Users/juahernandez/Developer/static.univision.com/especial/deportes/mundial-rusia-2018/ultras-mundial-racismo-en-la-otra-cara-del-mundial-src/.cache/json/layout-internal.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/internal.js